import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { SubheaderService } from 'src/app/core';
import { AttachmentTypeService } from 'src/app/core/services/attachment-type.service';
import { AttachmentType } from 'src/app/shared/models/schedule.model';

@Component({
  selector: 'app-type-add',
  templateUrl: './type-add.component.html',
  styleUrls: ['./type-add.component.scss']
})
export class TypeAddComponent implements OnInit {

  form: FormGroup;
  attachmentType: AttachmentType;
  typeId?: number = null;
  isModify = false;

  // Subscriptions
  private subscriptions: Subscription[] = [];

  constructor(
    private subheaderService: SubheaderService,
    private attachmentTypeService: AttachmentTypeService,
    private toastService: ToastrService,
    private postFB: FormBuilder,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    protected sanitizer: DomSanitizer,
  ) {
    this.initBreadCrumbs();
    this.createForm();
    this.typeId = this.activatedRoute.snapshot.params?.id;
    this.isModify = !!this.typeId;
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((el) => el.unsubscribe());
  }

  ngOnInit(): void {
    this.loadData();
  }

  loadData(): void {
    if (!this.typeId) { return; }

    this.attachmentTypeService.getById(this.typeId).subscribe((response) => {
      if (response.isSuccess) {
        this.attachmentType = response.result;
        this.pathValue();
      } else {
        this.toastService.error(
          'Lấy dữ liệu thất bại, xin vui lòng thử lại!'
        );
      }
    });
  }

  pathValue(): void {
    Object.keys(this.attachmentType).forEach((key: string) => {
      if (this.form.contains(key)) {
        const formControl = this.form.get(key);
        if (this.attachmentType[key] && formControl) {
          formControl.patchValue(this.attachmentType[key]);
        }
      }
    });
  }

  initBreadCrumbs(): void {
    this.subheaderService.setBreadcrumbs([
      { title: 'Quản lý loại tài liệu', page: `admin/attachment-type` },
      { title: 'Thêm mới', page: `admin/attachment-type/add` },
    ]);
  }

  createForm(): void {
    this.form = this.postFB.group({
      title: [null, Validators.compose([Validators.required])],
      active: [true],
      sortOrder: [0]
    });
  }

  isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.form.controls[controlName];
    if (!control) {
      return false;
    }

    const result =
      control.hasError(validationType) && (control.dirty || control.touched);
    return result;
  }

  onCreate(): void {
    if (!this.isCheckValiForm()) { return; }

    const payLoad = this.preparePost();
    this.attachmentTypeService.create(payLoad).subscribe((res) => {
      if (res.isSuccess) {
        this.toastService.success('Thêm mới thành công!');
        this.router.navigateByUrl('/admin/attachment-type');
      }
      else {
        this.toastService.error(
          'Thêm mới thất bại, xin vui lòng thử lại!'
        );
      }
    });
  }

  onSave(): void {
    if (!this.isCheckValiForm()) { return; }

    const payLoad = this.preparePost();
    payLoad.id = this.typeId;
    this.attachmentTypeService.update(payLoad)
      .subscribe((response) => {
        if (response.isSuccess) {
          this.toastService.success('Bạn đã cập nhật tin thành công!');
          this.router.navigateByUrl('/admin/attachment-type');
        }
        else {
          this.toastService.error(
            'Đã xảy ra lỗi trong quá trình lưu địa điểm, xin vui lòng thử lại!'
          );
        }
      });
  }

  isCheckValiForm(): boolean {
    const controls = this.form.controls;
    if (this.form.invalid) {
      Object.keys(controls).forEach((controlName) =>
        controls[controlName].markAsTouched()
      );

      return false;
    }

    return true;
  }

  preparePost(): AttachmentType {
    const controls = this.form.controls;
    const model: AttachmentType = {
      title: controls.title.value,
      active: controls.active.value,
      sortOrder: controls.sortOrder.value
    };

    return model;
  }

}
